
    export default {
      mounted() {
        this.handleKeypress = (event) => {
          if (event.key !== "Enter") return

          const emailInput = this.el.querySelector('[data-partner-invite-row] input[type="email"]')
          if (document.activeElement !== emailInput) return

          event.preventDefault()
          emailInput.blur()
          this.el.querySelector('[data-role="add-partner-button"]')?.click()
          emailInput.focus()
        }

        this.el.addEventListener("keypress", this.handleKeypress)
      },
      destroyed() {
        this.el.removeEventListener("keypress", this.handleKeypress)
      }
    }
  